import React from 'react';

import classes from './DriveUp.module.scss';

function DriveUp() {
    return (
        <div className={`${classes.driveUpAccess}`}>
            <img src='https://ik.imagekit.io/bytcx9plm/vehicle.png' />
        </div>
    );
}

export default DriveUp;
